// extracted by mini-css-extract-plugin
module.exports = {"rowHover":"styles_rowHover__1jBSJ","tableRow":"styles_tableRow__1VzNu","number":"styles_number__3PimT"};